<template>
  <div class="ov-toolbar">
    <div class="ov-presets">
      <Tooltip v-for="preset in presets" :key="preset.key" :text="presetHelp(preset)" position="top">
        <button
          class="ov-preset"
          :class="{ active: period.key === preset.key }"
          @click="$emit('select', { key: preset.key })"
        >{{ $t(preset.label) }}</button>
      </Tooltip>
    </div>
    <div class="ov-period-custom" :class="{ active: period.key === 'custom' }">
      <ReportingDatePicker
        :date-start="customStart"
        :date-end="customEnd"
        compare-mode="none"
        @apply="onCustomPeriod"
      />
    </div>
    <span v-if="updating" class="ov-updating">{{ $t('dash.overview.updating') }}</span>
    <Tooltip :text="$t('dash.overview.refresh')" position="top" class="ov-toolbar-refresh">
      <button class="ov-refresh" :disabled="loading" @click="$emit('refresh')">
        <i class="material-icons" :class="{ spin: loading }">refresh</i>
      </button>
    </Tooltip>
  </div>
</template>

<script>
import moment from 'moment'
import Tooltip from '../tooltip/tooltipInit.vue'
import ReportingDatePicker from '../reporting-web/ReportingDatePicker.vue'
import { PRESETS, presetHelp } from './periods'

/**
 * Choix de période (raccourcis, plage libre, rafraîchissement) : overview général et tableaux de bord
 */
export default {
  name: 'OverviewPeriodBar',

  components: { Tooltip, ReportingDatePicker },

  props: {
    period: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    updating: { type: Boolean, default: false }
  },

  data() {
    return { presets: PRESETS }
  },

  computed: {
    customStart() {
      return this.period.key === 'custom' ? this.period.start : moment().subtract(29, 'days').format('YYYY-MM-DD')
    },

    customEnd() {
      return this.period.key === 'custom' ? this.period.end : moment().format('YYYY-MM-DD')
    }
  },

  methods: {
    // Dates exactes couvertes par une période (Tooltip des boutons de période)
    presetHelp(preset) {
      return presetHelp(this, preset)
    },

    onCustomPeriod({ dateStart, dateEnd }) {
      if (!dateStart || !dateEnd) return
      this.$emit('select', { key: 'custom', start: dateStart, end: dateEnd })
    }
  }
}
</script>
